import { isLetterCostPerOrder } from './userUtils';

/**
 * 料金部分を表示するか
 * @param order 注文
 * @param user ユーザー
 * @return {bool}
 */
export const isDisplayCost = (order, user) => {
    // フォローコールがある場合 => 表示しない
    if (order && order.follow_call_order) {
      return false;
    }

    // 現在1注文ごとにレター送付の料金が発生するか
    // TODO データ移行が終わったら削除する条件
    if (isLetterCostPerOrder(user)) {
      return true;
    } else {
      return false;
    }

    // レターで料金が0か
    // TODO データ移行が終わったら復元する条件
    // TODO 過去BDRプランで注文したデータでもtotal_costが0より大きいので、0に移行する
    // TODO 2024/01/24 時点では、BDRからProプランになったユーザーは、isLetterCostPerOrderの条件で、表示/非表示されてしまう
    // if (order.letter_order && order.letter_order.total_cost === 0) {
    //   return false;
    // } else {
    //   return true;
    // }
}

/**
 * フォローコールあり・なしを表示するか
 * @param order 注文
 * @param user ユーザー
 * @return {bool}
 */
export const isDisplayFollowCallExist = (order, user) => {
  const isOrderedLetter = order.letter_order ? true : false;

  // フォローコールのみ場合 => 表示しない
  if (!isOrderedLetter) {
    return false;
  }

  // 現在1注文ごとにレター送付の料金が発生するか
  // TODO データ移行が終わったら削除する条件
  if (isLetterCostPerOrder(user)) {
    return false;
  } else {
    return true;
  }

  // レターで料金が0か
  // TODO データ移行が終わったら復元する条件
  // TODO 過去BDRプランで注文したデータでもtotal_costが0より大きいので、0に移行する
  // TODO 2024/01/24 時点では、BDRからProプランになったユーザーは、isLetterCostPerOrderの条件で、表示/非表示されてしまう
  // if (order.letter_order && order.letter_order.total_cost === 0) {
  //   return true;
  // } else {
  //   return false;
  // }
}



// WEBPACK FOOTER //
// ./src/utils/orderUtils.js